import React, { useRef, forwardRef, useImperativeHandle } from "react";
import classNames from "classnames";

// Icons
import CloseIcon from "@vahak/core/dist/icons/closeOdc.svg";

// Styles
import Styles from "./Tooltip.module.scss";
import { useHover } from "@vahak/core/dist/hooks/useHover";
import { useOutsideClick } from "@vahak/core/dist/hooks/useOutsideClick";
import BottomSheet from "@vahak/core-ui/dist/components/BottomSheet";
import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";

export interface TooltipProps {
    wrapperClassName?: string;
    wrapperStyle?: { [key: string]: any };
    tooltipContainerClassName?: string;
    tooltipTogglerClassName?: string;
    elmref?: string;
    handlepopupview?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    tooltipToggler: React.ReactNode;
    appearOnHover?: boolean;
    tooltipContent: React.ReactNode;
    position?: "top" | "left" | "bottom" | "right";
    fallbackText?: React.ReactNode;
    shouldOpenInBottomSheet?: boolean;
    isCloseIconDisabled?: boolean;
    enabled?: boolean;
}

const Tooltip = forwardRef(
    (
        {
            wrapperClassName,
            wrapperStyle = {},
            tooltipContainerClassName,
            tooltipTogglerClassName,
            tooltipToggler,
            appearOnHover = false,
            tooltipContent,
            position = "top",
            fallbackText,
            shouldOpenInBottomSheet = false,
            isCloseIconDisabled = false,
            enabled = true
        }: TooltipProps,
        ref
    ): JSX.Element => {
        const [popupView, elmRef, handlePopupView] = useOutsideClick(false);
        const togglerRef = useRef<HTMLDivElement>(null);
        const tooltipContainerRef = useRef<HTMLDivElement>(null);
        const isHovered = useHover(togglerRef);
        const isMobile = useMediaQuery({ queryType: "mobile" });

        // const [tooltipContainerHeight, setTooltipContainerHeight] = useState(0);
        // const [tooltipLines, setTooltipLines] = useState(0);

        const onClickToggler = () => {
            if (!appearOnHover) {
                handlePopupView();
            }
        };

        useImperativeHandle(ref, () => ({
            onClickToggler
        }));

        /**
         * This piece of code is required for future reference will be removed later
         */

        // useEffect(() => {
        //     if (tooltipContainerRef.current || elmRef.current) {
        //         const tooltipContainerHeight = appearOnHover
        //             ? tooltipContainerRef.current?.clientHeight
        //             : elmRef.current?.clientHeight;
        //         const tooltipOffsetHeight = appearOnHover
        //             ? tooltipContainerRef.current?.offsetHeight
        //             : elmRef.current?.offsetHeight;
        //         const tooltipLineHeight = appearOnHover
        //             ? tooltipContainerRef.current?.style.lineHeight
        //             : elmRef.current?.style.lineHeight;
        //         setTooltipContainerHeight(tooltipContainerHeight);
        //         setTooltipLines(tooltipOffsetHeight / Number(tooltipLineHeight.split(/(\d+)/)[1]));
        //         console.log(tooltipOffsetHeight / Number(tooltipLineHeight.split(/(\d+)/)[1]), "tooltipLineNumber");
        //     }
        // }, [appearOnHover, elmRef, isHovered]);
        // style={{ ["--tooltipContainer-height" as any]: `${10 / 6}px` }}
        // style={{ top: `-${tooltipContainerHeight + 200}%`, lineHeight: "16px" }}
        return (
            <div className={classNames(Styles.tooltipWrapper, wrapperClassName)} style={wrapperStyle}>
                {((appearOnHover && isHovered && enabled) || popupView) && !shouldOpenInBottomSheet && (
                    <div
                        className={classNames(Styles.tooltipContainer, tooltipContainerClassName, Styles[position])}
                        ref={!appearOnHover ? elmRef : tooltipContainerRef}
                    >
                        {!appearOnHover && !isCloseIconDisabled && (
                            <div className={Styles.closeIcon} onClick={handlePopupView}>
                                <CloseIcon />
                            </div>
                        )}
                        {tooltipContent ? tooltipContent : fallbackText}
                    </div>
                )}
                <div
                    ref={togglerRef}
                    className={classNames(Styles.contentWrapper, tooltipTogglerClassName)}
                    onClick={enabled ? onClickToggler : undefined}
                >
                    {tooltipToggler}
                </div>
                {isMobile && shouldOpenInBottomSheet && popupView && (
                    <BottomSheet isOpen={popupView && shouldOpenInBottomSheet} onToggle={handlePopupView}>
                        {tooltipContent ? tooltipContent : fallbackText}
                    </BottomSheet>
                )}
            </div>
        );
    }
);

export default Tooltip;
